module.exports = __webpack_public_path__ + "img/UP_medical.a4d066fd.jpg";